import { useEffect, useState } from 'react';
import { List, Datagrid, TextField,
         Edit, SimpleForm, Create, FunctionField,
         NumberField, EditButton, DeleteButton,
         TextInput,
         NumberInput} from 'react-admin';

export const WebsiteList = props => (
  <List {...props}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="description" />
      <TextField source="threat_model_path" />
    </Datagrid>
  </List>
);

export const AssignmentList = props => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="account_id" />
      <TextField source="website_id" />
      <NumberField source="order_index" />
      <NumberField source="time_limit_minutes" />
      <NumberField source="time_limit_extra_minutes" />
      <NumberField source="time_limit_document_minutes" />
      <FunctionField source="assigned_at" render={
          record => {
            return new Date(record.assigned_at).toLocaleString(undefined, {timeZoneName: "shortOffset"});
          }
      } />
      <FunctionField source="server_started_at" render={
          record => {
            if (!record.server_started_at) return "";
            return new Date(record.server_started_at).toLocaleString(undefined, {timeZoneName: "shortOffset"});
          }
      } />
      <FunctionField source="server_stopped_at" render={
          record => {
            if (!record.server_stopped_at) return "";
            return new Date(record.server_stopped_at).toLocaleString(undefined, {timeZoneName: "shortOffset"});
          }
      } />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const AssignmentEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="account_id" />
      <TextInput source="website_id" />
      <NumberInput source="order_index" />
      <NumberInput source="time_limit_minutes" />
      <NumberInput source="time_limit_extra_minutes" />
      <NumberInput source="time_limit_document_minutes" />
    </SimpleForm>
  </Edit>
);

// Pentest times are pre-filled with this environment's defaults (PENTEST_*_MINUTES
// in the backend .env); change them here only to override one participant.
// Document-review time left empty = 15 min (TM) / 10 min (No-TM), set at review start.
export const AssignmentCreate = props => {
  const [defaults, setDefaults] = useState(null);
  useEffect(() => {
    fetch('/api/admin/assignment-defaults', {
      headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` },
    })
      .then(r => (r.ok ? r.json() : {}))
      .then(d => setDefaults({ order_index: 1, ...d }))
      .catch(() => setDefaults({ order_index: 1 }));
  }, []);
  if (!defaults) return null;  // defaultValues are read once, so wait for them
  return (
    <Create {...props}>
      <SimpleForm defaultValues={defaults}>
        <TextInput source="account_id" />
        <TextInput source="website_id" />
        <NumberInput source="order_index" />
        <NumberInput source="time_limit_minutes" label="Mandatory pentest minutes" />
        <NumberInput source="time_limit_extra_minutes" label="Optional extra minutes" />
        <NumberInput source="time_limit_document_minutes" label="Document review minutes (empty = 15 TM / 10 No-TM)" />
      </SimpleForm>
    </Create>
  );
};
